import * as gs from "@ivanlog/gs";
import * as com from "./tmpls";
import { BiMath } from "../libs/BiMath";

export class CmpInputAddress extends com.CmpInputAddressBase {

    private _onChangeValue:gs.EventGS<string>;
    private _onChangeValueToken:gs.EventGSToken<string>;

    constructor() {
        super();
        this._onChangeValueToken = new gs.EventGSToken<string>();
        this._onChangeValue = new gs.EventGS(this._onChangeValueToken);
        let cacheValue = "0x";
        this.ctrls.iValue.el.addEventListener('input',async ()=>{
            let value = this._clearValueFunc(this.ctrls.iValue.value);
            if (value===false) {this.ctrls.iValue.value = cacheValue; return;}
            cacheValue = value;
            if (BiMath.isValidAddress(cacheValue))
                this._onChangeValueToken.invoke(cacheValue);
        });
    }

    public get onChangeValue() {return this._onChangeValue;}

    public setToken(symbol:string, address:string)
    {
        this.ctrls.lAddressName.text = symbol;
        this.ctrls.imgIcon.src="files/images/erc20/"+address.toLowerCase()+".webp";
        this.ctrls.iValue.value=address;
    }

    private _clearValueFunc(value:string){         
        if (value=="") return value;
        if (!value.startsWith("0x")) value = "0x" + value;
        const regex = /^0x[0-9A-Fa-f]+$/;
        if (!regex.test(value)) return false;
        return value;
    }
}